import React from "react";
import { getImageUrl } from "../../utils/generalLiveCenter";
import NextImage from "../common/NextImage";

const BasketballRounds = ({ score, data, sport = "basketball" }) => {
  return (
    <div className="lineupbox">
      <div className="global_table player_lineup">
        <table>
          <thead>
            <tr>
              <th>Rounds</th>
              <th>Q1</th>
              <th>Q2</th>
              <th>Q3</th>
              <th>Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="players_inf">
                  <div className="avtar">
                    <NextImage
                      src={getImageUrl("", "", sport, data?.htid)}
                      width={26}
                      height={26}
                      alt="player"
                    />
                  </div>
                  <div className="avtar_inf">
                    <strong className="name small">{data?.htn}</strong>
                  </div>
                </div>
              </td>
              {score.map((h, i) => (
                <td key={data?.htid + i}>{h?.hScore}</td>
              ))}
            </tr>
            <tr>
              <td>
                <div className="players_inf">
                  <div className="avtar">
                    <NextImage
                      src={getImageUrl("", "", sport, data?.atid)}
                      width={26}
                      height={26}
                      alt="player"
                    />
                  </div>
                  <div className="avtar_inf">
                    <strong className="name small">{data?.atn}</strong>
                  </div>
                </div>
              </td>
              {score.map((h, i) => (
                <td key={data?.atid + i}>{h?.aScore}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BasketballRounds;
